// Import: Middleware Action & Custom Types
import { CLEAN_LEAD, CLEAN_LEAD_ERROR } from '_models/redux/types';

// Action function
export const cleanLeadsAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_LEAD,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_LEAD_ERROR,
      payload: undefined,
    });
  }
};
